import React, {useEffect, useState} from 'react';
import SPContent from "components/supplier-entry/SPEntryHome/SPContent";
import SPHeader from "components/supplier-entry/SPEntryHome/SPHeader";
import SPStoreListDrawer from "../../../components/carRental/storeManagement/SPStoreListDrawer";
import SPVenhicleDrawer from "../../../components/carRental/vehicleManagement/SPVenhicleDrawer";
import {useSupplierEntry} from "../../../hooks/supplier-entry";
import SPBreadcrumb from "../../../components/base/SPBreadcrumb";
import { message, Spin } from 'antd';

interface IPageProps {
	enums?: any
	permission?: any
	userInfo?: any
}

const SPPage: React.FC<IPageProps> = props => {
	const { enums, userInfo, permission } = props;
  const [authStatus, setAuthStatus] = useState<any>({});
  const { getAuthStatus } = useSupplierEntry();
  const [loading, setLoading] = useState<boolean>(true);

  let timer:any = null;

  const handleAuthStatusGet = () => {
    getAuthStatus({}).then((res: any) => {
      setLoading(false);
      setAuthStatus(res?.data || {});
      const { pay_deposit_status, seal_status } = res?.data || {};
      if (pay_deposit_status === 1 && seal_status !== 1) {
        if (timer) clearInterval(timer);
        timer = setInterval(() => {
          getAuthStatus({}).then((res: any) => {
            setLoading(false);
            setAuthStatus(res?.data || {});
            if (res?.data?.seal_status === 1) {
              clearInterval(timer);
              message.success('认证成功');
            }
          })
        }, 5000);
      }
    }).catch(() => {
      setLoading(false);
    });
  }

  useEffect(() => {
    handleAuthStatusGet();
    return () => {
      if (timer) clearInterval(timer);
    }
  }, [])

	return (
		<>
			{!loading && <SPHeader authStatus={authStatus}></SPHeader>}
			{
        userInfo.admin && !userInfo?.enter ? <div style={{
					height: '24px',
					width: '100%',
				}}></div> : null
			}
			<SPContent authStatus={authStatus} permission={permission}></SPContent>
		</>
	);
};

export default SPPage;
